// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = function (createUi) {
    var ui;
    ui = createUi(require("./CsvErrorTooltip.html"), {});
    return ui;
  };
}.call(this));
